export const API_BASE = 'https://api.brewui.com';
export const MARKETING_URL = 'https://brewui.com/';
export const STRIPE_API_KEY = 'pk_live_CoatxZi45SRegEJ8Hx5lfZiw';
export const PRODUCTION_BUILD_TYPE = process.env.REACT_APP_PRODUCTION_BUILD_TYPE || 'pwa';
